module.exports = __webpack_public_path__ + "img/08236842000159.423a405b.png";